module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-home-a6f5db84ca0a886b1555cf851fa411a7.png";